import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import get from 'lodash/get';
import moment from 'moment';

import Content from '../components/MainContent';
import Button from '../../../../components/Button';
import DatepickerRange from '../../components/DatepickerRange';
import { getQuery } from '../../../pages/Paspor/function';

import {
  getInvestmentInquiryList,
  getTradeInquiryList,
  getStatistic,
  getStatisticWeek,
  getStatisticMonth
} from './action';
import { getStatisticDate, downloadFile } from '../../functions';

const InvestasiPerdagangan = ({
  investmentList,
  tradeList,
  getInvestmentInquiryList,
  getTradeInquiryList,
  statistic,
  statisticWeek,
  statisticMonth,
  getStatistic,
  getStatisticWeek,
  getStatisticMonth,
  history
}) => {
  const title = 'EKONOMI - Berbisnis di Indonesia';
  const { tab = 1 } = getQuery(history);

  const date = new Date();
  const last = new Date();
  const [startDate, setStartDate] = useState(date);
  const [endDate, setEndDate] = useState(last);

  const [activeTab, setActiveTab] = useState(String(tab));
  const [page, setPage] = useState(1);
  const [query, setQuery] = useState();
  const [pageDivider, setPageDivider] = useState(5);

  const tabList = {
    '1': 'investment',
    '2': 'trade'
  };

  const activeData = activeTab === '1' ? investmentList : tradeList;
  const listData = get(activeData, ['data', 'data', 'data']) || [];
  const pagination = get(activeData, ['data', 'pagination']) || [];
  const loading = get(activeData, ['status']) === 'pending';

  const getSummaryData = () => {
    const summaryData = [
      {
        title: 'Data Hari Ini',
        subtitle: title,
        numOfIn: String(0)
      },
      {
        title: 'Data Minggu Ini',
        subtitle: title,
        numOfIn: String(0)
      },
      {
        title: 'Data Bulan Ini',
        subtitle: title,
        numOfIn: String(0)
      }
    ];
    const dayStatistic = get(statistic, ['data']) || [];
    const weekStatistic = get(statisticWeek, ['data']) || [];
    const monthStatistic = get(statisticMonth, ['data']) || [];

    const setTotal = (statistic, index) => {
      statistic.map(({ status, total }) => {
        switch (status) {
          case null:
            summaryData[index].numOfIn = String(total);
            break;
        }
      });
    };

    setTotal(dayStatistic, 0);
    setTotal(weekStatistic, 1);
    setTotal(monthStatistic, 2);

    return summaryData;
  };

  const summaryData = getSummaryData();

  const loadData = (type) => {
    const params = {
      per_page: pageDivider,
      page: page,
      from: moment(startDate).format('YYYY-MM-DD'),
      to: moment(endDate).format('YYYY-MM-DD')
    };

    if (query && query !== '') {
      params.q = query;
    }

    if (type === 'trade') {
      getTradeInquiryList(params);
    } else if (type === 'investment') {
      getInvestmentInquiryList(params);
    }
  };

  const loadStatisticData = (type) => {
    const { today, startWeek, endWeek, startMonth, endMonth } = getStatisticDate();
    getStatistic(
      {
        from: today,
        to: today
      },
      type
    );
    getStatisticWeek(
      {
        from: startWeek,
        to: endWeek
      },
      type
    );
    getStatisticMonth(
      {
        from: startMonth,
        to: endMonth
      },
      type
    );
  };

  const handlerDownload = () => {
    const params = {
      from: moment(startDate).format('YYYY-MM-DD'),
      to: moment(endDate).format('YYYY-MM-DD')
    };
    const fileName = `${title}-${params.from}-${params.to}`;
    downloadFile(`${tabList[activeTab]}/inquiry`, params, fileName);
  };

  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    loadData(tabList[activeTab]);
    loadStatisticData(tabList[activeTab]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab, pageDivider, page, query]);

  return (
    <div className='admin-visa'>
      <Content
        title={title}
        dataTab={listData}
        summaryData={summaryData}
        onTabChanges={setActiveTab}
        onPageChanges={setPage}
        onQueryChanges={setQuery}
        onPageDividerChanges={setPageDivider}
        defaultActiveTab={activeTab}
        pagination={pagination}
        typeTab={tabList[activeTab]}
        type='ekobisnis'
        loading={loading}
        topActionComponent={
          <div className='detail-action' style={{ display: 'flex' }}>
            <DatepickerRange
              startDate={startDate}
              setStartDate={setStartDate}
              endDate={endDate}
              setEndDate={setEndDate}
              onCalendarClose={() => loadData(tabList[activeTab])}
            />
            <Button color='info' onClick={handlerDownload} style={{ marginLeft: '16px' }}>
              Download
            </Button>
          </div>
        }
      />
    </div>
  );
};

InvestasiPerdagangan.propTypes = {
  investmentList: PropTypes.object,
  tradeList: PropTypes.object,
  getInvestmentInquiryList: PropTypes.func,
  getTradeInquiryList: PropTypes.func,
  statistic: PropTypes.object,
  statisticWeek: PropTypes.object,
  statisticMonth: PropTypes.object,
  getStatistic: PropTypes.func,
  getStatisticWeek: PropTypes.func,
  getStatisticMonth: PropTypes.func
};

const mapStateToProps = (state) => ({
  investmentList: {
    status: state.getInvestmentInquiryListReducer.status,
    error: state.getInvestmentInquiryListReducer.error,
    data: state.getInvestmentInquiryListReducer.data
  },
  tradeList: {
    status: state.getTradeInquiryListReducer.status,
    error: state.getTradeInquiryListReducer.error,
    data: state.getTradeInquiryListReducer.data
  },
  statistic: {
    status: state.getBisnisStatisticReducer.status,
    error: state.getBisnisStatisticReducer.error,
    data: state.getBisnisStatisticReducer.data
  },
  statisticWeek: {
    status: state.getBisnisStatisticWeekReducer.status,
    error: state.getBisnisStatisticWeekReducer.error,
    data: state.getBisnisStatisticWeekReducer.data
  },
  statisticMonth: {
    status: state.getBisnisStatisticMonthReducer.status,
    error: state.getBisnisStatisticMonthReducer.error,
    data: state.getBisnisStatisticMonthReducer.data
  }
});

export default compose(
  connect(mapStateToProps, {
    getInvestmentInquiryList,
    getTradeInquiryList,
    getStatistic,
    getStatisticWeek,
    getStatisticMonth
  }),
  withRouter
)(InvestasiPerdagangan);
